import * as API from "./apis"

export default app => {
    //Register all possible provider here
    app.provide('$api', API)
}